import React from 'react';
import cn from 'classnames';

import { IProps } from './types';

import styles from '../../../AuthNew.module.scss';
import { Button } from '@infologistics/frontend-libraries';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const LoginButtons = ({ main, isDisabled, left, right, className }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.buttons, className, 'full-width')}>
      {/* <div className={cn(styles.buttons, 'grid-3 grid-no-response')}> */}
      <Button
        theme='primary'
        size='large'
        // classes={cn(styles.button, styles.inputs, styles.input_radius, 'grid-item-3 d-flex align-items-center justify-content-center')}
        classes={cn(styles.button, styles.inputs, styles.input_radius, 'full-width d-flex align-items-center justify-content-center')}
        type={main.onClick ? undefined : 'submit'}
        isDisabled={isDisabled}
        onClick={main.onClick}
      >
        <span className={cn('fw-700')}>{t(main.text)}</span>
      </Button>
      {left.onLink && (
        <Link to={left.onLink} className={cn('d-block', styles.textColored)}>
          {t(left.text)}
        </Link>
      )}
      <div className='d-flex justify-content-between'>
        {left.onClick && (
          <Button onClick={left.onClick} theme='link' linkStyle='none' classes={cn('grid-item-1', styles.textColored)}>
            {t(left.text)}
          </Button>
        )}

        {right && (
          <Button onClick={right.onClick} theme='link' linkStyle='none' classes={cn('grid-item-1', styles.textColored)}>
            {t(right.text)}
          </Button>
        )}
      </div>
    </div>
  );
};
